// These enums must match those in drumkit/common/models/email_provider.

// NOTE: It's possible for a user to be integrated with both Front and either (Gmail or Outlook) (e.g. NFI, Trifecta).
// In that case, the BE returns the underlying email provider so the user can relink their account when required.
// If the user is integrated *only* with Front, the BE will return Front.
// As of Q4 2025, Front does not require user re-authorization as webhooks are set up at an organization level.
// https://www.notion.so/drumkitai/Email-Tokens-Webhooks-2b52b16b087a80dcbfccf776a3e7e0cb
// https://www.notion.so/drumkitai/Front-Guide-1e62b16b087a806f9a35c4e37eb85339
export enum EmailProvider {
  Gmail = 'gmail',
  Outlook = 'outlook',
  Front = 'front',
}

export const EmailProviderDisplayName: Record<EmailProvider, string> = {
  [EmailProvider.Gmail]: 'Gmail',
  [EmailProvider.Outlook]: 'Outlook',
  [EmailProvider.Front]: 'Front',
};
